import React from 'react';
import { Box, Dialog, List, ListItem, Typography } from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SearchIcon from '@material-ui/icons/Search';
import InfoListItem from '../InfoListItem';
import useBooking from '../../../../../../context/useBooking';
import { useTranslations, ToggleRPC, useIsDesktop } from 'components/utilities';

const HoursInfoListItem = () => {
	const { t } = useTranslations();
	const { booking } = useBooking();

	const officeHoursFormatted =
		booking.car.office.profile.office_hours_formatted;

	const isDesktop = useIsDesktop();

	return (
		<ToggleRPC>
			{({ on, toggle }) => (
				<>
					<Dialog open={on} onClose={toggle} fullWidth maxWidth="sm">
						<List>
							{officeHoursFormatted.map((hours) => (
								<ListItem key={hours.days}>
									<Typography>
										{hours.days} - {hours.hours}
									</Typography>
								</ListItem>
							))}
						</List>
					</Dialog>
					<InfoListItem
						button
						onClick={toggle}
						icon={ScheduleIcon}
						info={t('booking.officeHours')}
						actions={
							<Box display="flex" justify="flex-end">
								<SearchIcon fontSize={isDesktop ? 'large' : 'default'} />
							</Box>
						}
					/>
				</>
			)}
		</ToggleRPC>
	);
};

export default HoursInfoListItem;
